export const DATE_NAME: string = 'f-m-date';
export const DATE_TIME_NAME: string = 'f-m-date-time';
export const FILESIZE_NAME: string = 'f-m-filesize';
export const I18N_NAME: string = 'f-m-i18n';
export const MONEY_NAME: string = 'f-m-money';
export const PERIOD_NAME: string = 'f-m-period';
export const PHONE_NAME: string = 'f-m-phone';
export const POSTAL_CODE_NAME: string = 'f-m-postal-code';
export const TIME_ELAPSED_NAME: string = 'f-m-time-elapsed';
export const TIME_NAME: string = 'f-m-time';
export const TIME_PERIOD_NAME: string = 'f-m-time-period';


